import * as Sentry from '@sentry/browser'

// Actions
import { createHomeownerMessage } from '../api/mikasa/requests'
import { saveClientAnswer } from './client'
import { updateHomeLoan } from './home'
import { cancelEdit, cancelEditBalance } from './loan'

// Utils
import { hasCustomerToken } from '../auth'

// Selectors
import { selectClientLegacyId } from '../store/selectors/client'
import { selectCustomerProfile } from '../store/selectors/customerProfile'
import { selectHomeId } from '../store/selectors/home'
import { getLoanInterestRate, getLoanTermYears } from '../store/selectors/home/loans'

// Constants
import { PREFERENCES } from '../constants/messages'
import { QUESTION_ACKNOWLEDGED_TUNE_VALUE } from '../constants/valuation'
import {
  DIRECT_MESSAGE_FAILURE,
  DIRECT_MESSAGE_REQUEST,
  DIRECT_MESSAGE_SUCCESS,
  SET_HO_CHECKED_NUMBERS,
  SET_HO_LOAN_FOCUS
} from './actionTypes'

const toggleLoans =
  (loanFocus, options = {}) =>
  (dispatch, getState) => {
    const { loanFocus: currentLoanFocus } = getState().homeowner

    // Don't do anything if the loan focus is already set
    if (loanFocus === currentLoanFocus) {
      return
    }

    // Reset back to mortgages view uf ib edit balance view
    if (!loanFocus) {
      dispatch(cancelEditBalance())
      dispatch(cancelEdit())
    }

    dispatch({
      type: SET_HO_LOAN_FOCUS,
      loanFocus,
      disableAnimateLoanFocus: options.disableAnimate
    })
  }

export const openLoans = () => toggleLoans(true)

export const closeLoans = () => toggleLoans(false)

export const closeLoansNow = () => toggleLoans(false, { disableAnimate: true })

export const markLoansChecked = loans => async dispatch => {
  dispatch({
    type: SET_HO_CHECKED_NUMBERS
  })

  if (loans) {
    const confirmedLoans = loans.map(loan => ({
      loanUuid: loan.loanId,
      homeId: loan.homeId,
      rate: getLoanInterestRate(loan),
      termYears: getLoanTermYears(loan)
    }))
    await Promise.all(confirmedLoans.map(loan => updateHomeLoan(loan)(dispatch)))
  }
}

export const handleAcknowledgeTuneValue = () => async dispatch => {
  dispatch(
    saveClientAnswer({
      question: QUESTION_ACKNOWLEDGED_TUNE_VALUE,
      response: {
        value: true
      }
    })
  )
}

export const handleAcknowledgeTeaser = (question, value, notify) => async dispatch => {
  dispatch(
    saveClientAnswer(
      {
        question,
        response: {
          value
        }
      },
      notify && {
        successMessage: PREFERENCES.saved,
        failureMessage: PREFERENCES[hasCustomerToken() ? 'duh' : 'errored']
      }
    )
  )
}

export const sendRequestForDirectMessage = (message, topic, topicKey, trackingClient) => async (dispatch, getState) => {
  const state = getState()
  const homeId = selectHomeId(state)
  const customerProfile = selectCustomerProfile(state)
  const clientId = selectClientLegacyId(state)

  if (!customerProfile) {
    return
  }

  dispatch({ type: DIRECT_MESSAGE_REQUEST })
  try {
    await createHomeownerMessage(
      homeId,
      {
        topic,
        topicKey,
        message,
        clientId
      },
      trackingClient
    )

    dispatch({ type: DIRECT_MESSAGE_SUCCESS })
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: DIRECT_MESSAGE_FAILURE,
      error
    })
  }
}
